import React, { useEffect, useState } from 'react'
import Table from '../../components/Table/Table'
import config from '../../config';
import { X } from 'lucide-react';
import StockPaymentModel from '../../Models//StockPayment/StockPaymentModel';

function AllSupplierPayments({ closeModal, showModal, supplierName, supplierId }) {
    const [data, setData] = useState([]);
    const [error, setError] = useState(null);
    const [showPayModal, setShowPayModal] = useState(false);
    const [selectedStockPay, setSelectedStockPay] = useState(null);

    const columns = ['#', 'Stock Qty', 'Stock Total', 'CashAmount', 'Cheque Amount', 'Payment Date', 'Due', 'Stock Pay Status', 'Actions'];

    useEffect(() => {
        if (showModal && supplierId) {
            fetchSupplierPayments(supplierId);
        }
    }, [showModal, supplierId]);

    const fetchSupplierPayments = async (supplierId) => {
        try {
            const response = await fetch(`${config.BASE_URL}/stockPayments/${supplierId}`);
            if (!response.ok) {
                throw new Error(`Failed to fetch supplier payments: ${response.status} ${response.statusText}`);
            }
            const payments = await response.json();

            const formattedData = await Promise.all(payments.map(async (payment) => {
                const stockPayDate = new Date(payment.stockPayDate);
                const formattedStockPayDate = `${stockPayDate.getFullYear()}-${String(stockPayDate.getMonth() + 1).padStart(2, '0')}-${String(stockPayDate.getDate()).padStart(2, '0')} ${String(stockPayDate.getHours()).padStart(2, '0')}:${String(stockPayDate.getMinutes()).padStart(2, '0')}`;

                if (payment.due === 0 && payment.stockPaymentStatus !== "Paid") {
                    await handleStatusChange(payment.stockPaymentId, "Paid");
                }

                return {
                    stockPaymentId: payment.stockPaymentId,
                    stockQty: payment.stockQty,
                    total: payment.total,
                    cashAmount: payment.cashAmount,
                    chequeAmount: payment.chequeAmount,
                    formattedStockPayDate,
                    stockPayDate: stockPayDate,
                    due: payment.due,
                    stockPaymentStatus: payment.due === 0 ? "Paid" : payment.stockPaymentStatus,
                };
            }));

            const sortedByDate = formattedData.sort((a, b) => b.stockPayDate - a.stockPayDate);

            const sortedData = sortedByDate.sort((a, b) => {
                if (a.stockPaymentStatus === "Paid" && b.stockPaymentStatus !== "Paid") {
                    return 1;
                }
                if (a.stockPaymentStatus !== "Paid" && b.stockPaymentStatus === "Paid") {
                    return -1;
                }
                return 0;
            });

            const tableData = sortedData.map((item) => [
                item.stockPaymentId,
                item.stockQty,
                item.total,
                item.cashAmount,
                item.chequeAmount,
                item.formattedStockPayDate,
                item.due,
                <span style={{ color: item.stockPaymentStatus === "Paid" ? "green" : "red", fontWeight: "bold" }}>
                    {item.stockPaymentStatus}
                </span>,
                <div className='d-flex' style={{ justifyContent: 'center' }}>
                    {item.stockPaymentStatus !== "Paid" && (
                        <button className='btn btn-primary me-2' onClick={() => handleStockPay(item)}> Payment </button>
                    )}
                </div>
            ]);

            setData(tableData);
        } catch (err) {
            setError(err.message || 'An error occurred while fetching payments.');
        }
    };

    const handleStatusChange = async (stockPaymentId, newStatus) => {
        try {
            const response = await fetch(`${config.BASE_URL}/stockPayment/${stockPaymentId}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ stockPaymentStatus: newStatus }),
            });

            if (!response.ok) {
                throw new Error('Failed to update payment status');
            }
        } catch (error) {
            setError(error.message);
        }
    };

    const handleStockPay = async (item) => {
        setSelectedStockPay({
            ...item,
            supplierId: supplierId
        });
        setShowPayModal(true);
    };

    const handleCloseModal = () => {
        setShowPayModal(false);
    };

    const handleSavePayment = (paymentData) => {
        console.log("Payment saved:", paymentData);
        fetchSupplierPayments(supplierId);
        setShowPayModal(false);
        window.location.reload();
    };

    if (!showModal) return null;

    const title = `All Dues - ${supplierName || 'unknown'}`;
    const invoice = 'All Dues History.pdf';

    return (
        <div style={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%", backgroundColor: "rgba(0, 0, 0, 0.6)", display: "flex", justifyContent: "center", alignItems: "flex-start", paddingTop: "2%", zIndex: 1000, backdropFilter: "blur(3px)", animation: "fadeIn 0.3s ease" }}>
            <div className="p-3" style={{ position: "relative", background: "#f8f9fa", borderRadius: "16px", boxShadow: "0 12px 24px rgba(0, 0, 0, 0.15)", width: "80%", maxWidth: "1200px", maxHeight: "90vh", padding: "32px", overflowY: "auto", transform: "translateY(0)", animation: "slideUp 0.3s ease" }}>
                <button
                    onClick={closeModal}
                    style={{ position: "absolute", top: "16px", right: "16px", background: "#ffe5e5", border: "none", borderRadius: "50%", width: "40px", height: "40px", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", transition: "all 0.2s ease", color: "#dc3545" }}
                    aria-label="Close"
                    onMouseOver={(e) => {
                        e.target.style.background = "#ffcccc";
                        e.target.style.transform = "scale(1.1)";
                    }}
                    onMouseOut={(e) => {
                        e.target.style.background = "#ffe5e5";
                        e.target.style.transform = "scale(1)";
                    }}
                >
                    <X size={24} />
                </button>

                <h4 style={{ color: "#2c3e50", fontSize: "1.8rem", fontWeight: "600", marginBottom: "24px", borderBottom: "2px solid #eee", paddingBottom: "12px" }}>
                    All Dues of {supplierName || 'Unknown Supplier'}
                </h4>

                <div className='mt-3'>
                    <Table
                        search="Search by Stock Name"
                        data={data}
                        columns={columns}
                        showButton={false}
                        showDate={true}
                        title={title}
                        invoice={invoice}
                        showActions={false}
                        showDelete={false}
                    />
                    <StockPaymentModel
                        showModal={showPayModal}
                        closeModal={handleCloseModal}
                        stockPayment={selectedStockPay}
                        supplierName={supplierName}
                        supplierId={supplierId}
                        onSave={handleSavePayment}
                    />
                </div>

                <div className="modal-footer" style={{ marginTop: "24px", display: "flex", justifyContent: "flex-end", gap: "12px" }}>

                    <button
                        type="button"
                        style={{ backgroundColor: "#dc3545", color: "white", borderRadius: "8px", padding: "12px 24px", border: "none", cursor: "pointer", transition: "all 0.2s ease", fontWeight: "500", display: "flex", alignItems: "center", gap: "8px" }}
                        onClick={closeModal}
                        onMouseOver={(e) => {
                            e.target.style.backgroundColor = "#bb2d3b";
                            e.target.style.transform = "translateY(-1px)";
                        }}
                        onMouseOut={(e) => {
                            e.target.style.backgroundColor = "#dc3545";
                            e.target.style.transform = "translateY(0)";
                        }}
                    >
                        Close
                    </button>
                </div>
            </div>

            {error && (
                <div style={{ position: "fixed", bottom: "20px", left: "50%", transform: "translateX(-50%)", backgroundColor: "#fff3cd", color: "#856404", padding: "12px 24px", borderRadius: "8px", display: "flex", alignItems: "center", gap: "8px", boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)" }}>
                    <span>⚠️</span>
                    {error}
                </div>
            )}
        </div>
    )
}

export default AllSupplierPayments